import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  inject,
} from '@angular/core';

@Directive({ selector: '[mkpInViewportNotifier]' })
export class InViewportNotifierDirective implements AfterViewInit, OnDestroy {
  private readonly elementRef = inject(ElementRef, { host: true });

  @Output() visibilityChange = new EventEmitter<boolean>();

  @Input() rootMargin = 0;

  private observer!: IntersectionObserver;

  ngAfterViewInit(): void {
    const options: IntersectionObserverInit = {
      root: null,
      rootMargin: `${this.rootMargin}px`,
      threshold: 0.25,
    };
    this.observer = new IntersectionObserver(this.callback, options);
    this.observer.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }

  private callback: IntersectionObserverCallback = ([entry]) => {
    this.visibilityChange.emit(entry.isIntersecting);
  };
}
